module.exports = __webpack_public_path__ + "static/img/camerafor2.17e0313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/camerafor2.png
// module id = rLve
// module chunks = 24